import "./_tabs-max.scss";
export const TabsMax = ({ children }) => {
  return (
    <>
      <div className="tabs-max">
        <ul role="tablist">{children}</ul>
      </div>
    </>
  );
};
